/* eslint-disable camelcase */
/* eslint-disable no-mixed-operators */
import React from 'react';
import Routes from 'config/routes';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import {
  Grid,
  Header,
  Divider,
  Segment,
  Button,
  Form,
  Input,
  List,
  Popup,
  Icon,
} from 'semantic-ui-react';
import _ from 'lodash';

const kgrams = [
  { key: '0', text: '0', value: 0 },
  { key: '1', text: '1', value: 1 },
  { key: '2', text: '2', value: 2 },
  { key: '3', text: '3', value: 3 },
  { key: '4', text: '4', value: 4 },
  { key: '5', text: '5', value: 5 },
  { key: '6', text: '6', value: 6 },
  { key: '7', text: '7', value: 7 },
  { key: '8', text: '8', value: 8 },
  { key: '9', text: '9', value: 9 },
  { key: '10', text: '10', value: 10 },
  { key: '11', text: '11', value: 11 },
  { key: '12', text: '12', value: 12 },
  { key: '13', text: '13', value: 13 },
  { key: '14', text: '14', value: 14 },
  { key: '15', text: '15', value: 15 },
  { key: '16', text: '16', value: 16 },
  { key: '17', text: '17', value: 17 },
  { key: '18', text: '18', value: 18 },
  { key: '19', text: '19', value: 19 },
  { key: '20', text: '20', value: 20 },
  { key: '21', text: '21', value: 21 },
  { key: '22', text: '22', value: 22 },
  { key: '23', text: '23', value: 23 },
  { key: '24', text: '24', value: 24 },
  { key: '25', text: '25', value: 25 },
];

const grams = [
  { key: '0', text: '0', value: 0 },
  { key: '100', text: '100', value: 100 },
  { key: '200', text: '200', value: 200 },
  { key: '300', text: '300', value: 300 },
  { key: '400', text: '400', value: 400 },
  { key: '500', text: '500', value: 500 },
  { key: '600', text: '600', value: 600 },
  { key: '700', text: '700', value: 700 },
  { key: '800', text: '800', value: 800 },
  { key: '900', text: '900', value: 900 },
];

class OfferCalculator extends React.Component {
  state = {
    loading: true,
    iso_code: this.props.iso_code,
    customsCategoryID: null,
    itemStorePrice: null,
    weightKG: 0,
    weightGram: 100,
    storePriceUsd: '-',
    fees: '-',
    shippingIntl: '-',
    customs: '-',
    customsRate: -1,
    vat: '-',
    clearanceCharges: '-',
    subtotal: '-',
    promotionDiscount: 0,
    totalPrice: '-',
    currencyCode: '-',
    usdSign: '-',
    customsCategories: [],
    exchangeRate: 0,
    promotionHandlerMessage: '',
  };

  componentWillReceiveProps(np) {
    if (
      np.activeCustomsCategories.active_customs_categories &&
      !this.state.customsCategories.length
    ) {
      const mapped_customs_categories =
        np.activeCustomsCategories.active_customs_categories.map(
          (customs_category) => ({
            key: customs_category.id,
            text: customs_category.name,
            value: customs_category.id,
          })
        );

      this.setState({
        customsCategories: mapped_customs_categories,
        loading: false,
      });
    }
  }

  goToCart = () => {
    window.location = Routes.Cart;
  };

  handleFormSubmit = async () => {
    this.setState({ loading: true });
    if (!this.state.customsCategoryID) {
      toast.error(
        <div>
          <b>Error</b>, Please choose the customs category first.
        </div>
      );

      return;
    }

    if (!this.state.itemStorePrice) {
      toast.error(
        <div>
          <b>Error</b>, Please enter a valid store price.
        </div>
      );

      return;
    }
    const result = await this.props.calculateOfferItem({
      errorPolicy: 'all',
      variables: {
        customs_category_id: parseInt(this.state.customsCategoryID),
        store_price_usd: parseFloat(this.state.itemStorePrice),
        weight_kg: parseFloat(this.state.weightKG),
        weight_gram: parseFloat(this.state.weightGram),
      },
    });

    if (result.errors && result.errors.length) {
      this.setState({ formErrors: [result.errors[0].message] });
      toast.error(
        <div>
          <b>Error</b>, {result.errors[0].message}.
        </div>
      );
    } else if (result.data.calculateOfferItem) {
      this.setState({
        loading: false,
        usdSign: '$',
        storePriceUsd: _.round(
          result.data.calculateOfferItem.store_price_usd,
          2
        ),
        fees: _.round(result.data.calculateOfferItem.fees, 2),
        shippingIntl: _.round(result.data.calculateOfferItem.shipping_intl, 2),
        customs: _.round(result.data.calculateOfferItem.customs, 2),
        customsRate: _.round(result.data.calculateOfferItem.customs_rate, 2),
        clearanceCharges: _.round(
          result.data.calculateOfferItem.clearance_charges,
          2
        ),
        exchangeRate: result.data.calculateOfferItem.exchange_rate_value,
        subtotal: _.round(result.data.calculateOfferItem.subtotal, 2),
        vat: _.round(result.data.calculateOfferItem.vat, 2),
        currencyCode: result.data.calculateOfferItem.currency_code,
        promotionDiscount: _.round(
          result.data.calculateOfferItem.promotion_discount,
          2
        ),
        totalPrice: _.round(result.data.calculateOfferItem.total_price, 2),
        promotionHandlerMessage: result.data.calculateOfferItem.promo_message,
      });
    }
  };

  render() {
    const { customsCategoryID, itemStorePrice, weightKG, weightGram } =
      this.state;

    return (
      <Grid stackable centered>
        <Grid.Column width={8}>
          <Form>
            <Form.Group widths="equal">
              <Form.Select
                fluid
                label="Customs Category"
                options={this.state.customsCategories}
                value={customsCategoryID}
                onChange={(e, data) =>
                  this.setState({ customsCategoryID: data.value })
                }
              />
            </Form.Group>

            <Form.Field>
              <label className="pullLeft" htmlFor="presentation">
                Item Price (USD)
              </label>
              <Input
                type="number"
                step="0.1"
                min="0"
                value={itemStorePrice}
                onChange={(e) =>
                  this.setState({ itemStorePrice: e.target.value })
                }
              />
            </Form.Field>

            <Form.Group widths="equal">
              <Form.Select
                fluid
                label="Weight (Kilogram)"
                options={kgrams}
                value={weightKG}
                onChange={(e, data) => this.setState({ weightKG: data.value })}
              />
              <Form.Select
                fluid
                label="Weight (Gram)"
                options={grams}
                value={weightGram}
                onChange={(e, data) =>
                  this.setState({ weightGram: data.value })
                }
              />
            </Form.Group>

            <Form.Field>
              <Button
                onClick={() => this.handleFormSubmit()}
                basic
                primary
                size="large"
              >
                Calculate
              </Button>
            </Form.Field>
          </Form>
        </Grid.Column>

        <Grid.Column width={8}>
          {/* <Header>Item Cost</Header> */}
          <Segment>
            <Header size="small">Item Cost</Header>

            <List>
              <List.Item>
                <List.Content className="pullLeft">
                  Item Store Price
                </List.Content>
                <List.Content className="pullRight">
                  {this.state.usdSign}
                  {this.state.storePriceUsd}
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content className="pullLeft">
                  International Shipping{' '}
                  {this.state.iso_code === 'EG' &&
                    this.state.shippingIntl !== '-' && (
                      <Popup
                        trigger={<Icon link name="info circle" />}
                        content={'$3 per 100gm'}
                        position="top center"
                      />
                    )}
                </List.Content>
                <List.Content className="pullRight">
                  {this.state.usdSign}
                  {this.state.shippingIntl}
                </List.Content>
              </List.Item>

              {this.state.customs > 0 && (
                <List.Item>
                  <List.Content className="pullLeft">
                    Customs Fees
                    {this.state.customsRate > 0 && (
                      <Popup
                        trigger={<Icon link name="info circle" />}
                        content={`${this.state.customsRate}% of the item price, charged by customs authorities.`}
                        position="top center"
                      />
                    )}
                  </List.Content>
                  <List.Content className="pullRight">
                    {this.state.usdSign}
                    {this.state.customs}
                  </List.Content>
                </List.Item>
              )}

              <List.Item>
                <List.Content className="pullLeft">VAT</List.Content>
                <List.Content className="pullRight">
                  {this.state.usdSign}
                  {this.state.vat}
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content className="pullLeft">
                  Service Fees
                  {this.state.iso_code === 'EG' && this.state.fees !== '-' && (
                    <Popup
                      trigger={<Icon link name="info circle" />}
                      content={'$1 + 11% from the store price'}
                      position="top center"
                    />
                  )}
                </List.Content>
                <List.Content className="pullRight">
                  {this.state.usdSign}
                  {this.state.fees}
                </List.Content>
              </List.Item>

              {this.state.clearanceCharges > 0 && (
                <List.Item>
                  <List.Content className="pullLeft">
                    Clearance Charges
                    <Popup
                      trigger={<Icon link name="info circle" />}
                      content={
                        'Additional approvals required for this item type.'
                      }
                      position="top center"
                    />
                  </List.Content>
                  <List.Content className="pullRight">
                    {this.state.usdSign}
                    {this.state.clearanceCharges}
                  </List.Content>
                </List.Item>
              )}

              <Divider />

              <List.Item>
                <List.Content className="pullLeft">
                  Subtotal
                  {this.state.exchangeRate > 0 && (
                    <Popup
                      trigger={<Icon link name="info circle" />}
                      content={`USD Exchange Rate: ${this.state.exchangeRate}`}
                      position="top center"
                    />
                  )}
                </List.Content>
                <List.Content className="pullRight">
                  {this.state.subtotal} {this.state.currencyCode}
                </List.Content>
              </List.Item>

              {this.state.promotionDiscount < 0 && (
                <List.Item>
                  <List.Content className="pullLeft">
                    Promotion Discount
                    <Popup
                      trigger={<Icon link name="info circle" />}
                      content={this.state.promotionHandlerMessage}
                      position="top center"
                    />
                  </List.Content>
                  <List.Content
                    className="pullRight"
                    style={{ color: 'limegreen' }}
                  >
                    {this.state.promotionDiscount} {this.state.currencyCode}
                  </List.Content>
                </List.Item>
              )}

              <Divider />

              <List.Item>
                <List.Content className="pullLeft">
                  <b>FINAL PRICE </b>
                  <Popup
                    trigger={<Icon link name="info circle" />}
                    content={'No additional fees on delivery'}
                    position="top center"
                  />
                </List.Content>
                <List.Content className="pullRight">
                  <Header size="small" style={{ color: '#B12704' }}>
                    {this.state.totalPrice} {this.state.currencyCode}
                  </Header>
                </List.Content>
              </List.Item>
            </List>
          </Segment>
        </Grid.Column>
        <Grid.Column width={8} centered>
          <Button
            onClick={() => this.goToCart()}
            fluid
            style={{ justifyContent: 'center' }}
            color="orange"
          >
            Place Order
          </Button>
        </Grid.Column>
      </Grid>
    );
  }
}

const OFFER_CALCULATOR_MUTATION = gql`
  mutation calculateOfferItem(
    $customs_category_id: ID!
    $store_price_usd: Float!
    $weight_kg: Float!
    $weight_gram: Float!
  ) {
    calculateOfferItem(
      customs_category_id: $customs_category_id
      store_price_usd: $store_price_usd
      weight_kg: $weight_kg
      weight_gram: $weight_gram
    ) {
      store_price_usd
      fees
      shipping_intl
      customs
      customs_rate
      clearance_charges
      vat
      subtotal
      exchange_rate_value
      promotion_discount
      total_price
      currency_code
      promo_message
    }
  }
`;

const ACTIVE_CUSTOMS_CATEGORIES = gql`
  query ($iso_code: String!) {
    active_customs_categories(iso_code: $iso_code) {
      id
      name
      name_ar
    }
  }
`;

export default compose(
  injectIntl,
  graphql(OFFER_CALCULATOR_MUTATION, {
    name: 'calculateOfferItem',
  }),
  graphql(ACTIVE_CUSTOMS_CATEGORIES, {
    name: 'activeCustomsCategories',
    options: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
  })
)(OfferCalculator);



// WEBPACK FOOTER //
// ./app/components/CalculatorModal/OfferCalculator.js